module.exports = __webpack_public_path__ + "static/media/3 13 Tulleord Starter testen.ec4f4051.mp3";